import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ownerApi = axios.create({ baseURL: API, withCredentials: true });

// Access sessions are short; silently renew once with the refresh cookie, then retry
ownerApi.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config;
  const isAuthCall = cfg?.url?.startsWith("/auth/");
  if (error.response?.status === 401 && cfg && !cfg._retried && !isAuthCall) {
    cfg._retried = true;
    try {
      await ownerApi.post("/auth/refresh");
      return ownerApi(cfg);
    } catch {
      /* fall through to original error */
    }
  }
  return Promise.reject(error);
});

export async function getOwner() {
  try {
    const { data } = await ownerApi.get("/auth/me");
    return data;
  } catch (e) {
    if (e.response?.status !== 401) return false;
    try {
      await ownerApi.post("/auth/refresh");
      const { data } = await ownerApi.get("/auth/me");
      return data;
    } catch {
      return false;
    }
  }
}

export function apiErrorText(e) {
  const d = e?.response?.data?.detail;
  if (!d) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return String(d);
}
